import React from 'react';
import { Icons } from '../Icons/Icons';
import './Popup.scss';

interface PopupProps {
  children: React.ReactNode;
  width: string;
  onClose: () => void;
}

const Popup: React.FC<PopupProps> = ({ children, width, onClose }) => {
  return (
    <>
    <div className="popup-overlay" />
    <div
      className="popup"
      style={{ width }}
    >
      <div className="close" onClick={onClose}>
        {Icons.CloseIcon}
      </div>
      {children}
    </div>
    </>
  );
};

export default Popup;
